const truncateQuery = (text: string | any[], maxLength: number) => {
  if (text.length > maxLength) {
    return `${text.slice(0, maxLength)}...`;
  }
  return text;
};

export default truncateQuery;
